import _ from '@/assets/lib/my-lodash'
// const HEALTH_CHECK_INTERVAL_MS = 60 * 3 * 1000
const ENEPOINT_PREFIX = process.env.VUE_APP_ENDPOINT_PREFIX
const ENDPOINT_VALUES = {
  healthcheck: 'hc',
  pdf: 'pdf/',
  pdfDownload: 'pdf_download/',
  pdfDesign: 'pdf_design/',
  pdfDesignDownload: 'pdf_design_download/',
  pdfMail: 'pdf_mail/',
  pdfDesignMail: 'pdf_design_mail/',
  adtopPdfMail: 'adtop_pdf_mail/',
  sendAthlete: 'adtop_api_pdf/',
  sendAdtopApi: 'adtop_api_pdf/',
  sendYagishCareer: 'send_yagishcareer/',
  mynabiPdfMail: 'mynabi_pdf_mail/',
  cocorowaPdfMail: 'cocorowa_pdf_mail/',
  sendPdfMail: 'send_mail_pdf/',
  newGradPdfMail: 'newgrad_pdf_mail/',
  yagishRecruitPdfMail: 'yagishrecruit_pdf_mail/',
  pdfEprint: 'pdf_eprint/',
  pdfEprintAtokakin: 'pdf_eprint_atokakin/',
  html: 'html/test.html',
  screenshot: 'screenshot/',
  saveBackupdata: 'save_backupdata/',
  login: 'login/',
  ensureMember: 'auth/ensure_member/',
  gettoken: 'gettoken/',
  deleteUser: 'delete_user/',
  imageUpload: 'file/image/upload',
  tempSave: 'temp_save/',
  tempLoad: 'temp_load/',
  sendDataRoxx: 'send_data_roxx/',
  sendRecurrent: 'send_data_med/',
  sendLinkMedley: 'send_link_medley/',
  sendJigen: 'send_jigen/',
  sendMiraiyu: 'send_miraiyu/',
  sendTryt: 'send_tryt/',
  sendTrytApi: 'send_tryt_api/',
  sendKirara: 'send_kirara/',
  sendSimple: 'send_simple/',
  sendMynaviMs: 'send_mynavi_ms/',
  sendSystemShared: 'send_system_shared/',
  sendSystemShared23: 'send_system_shared23/',
  sendJobs919: 'send_jobs919/',
  sendCareerdraft: 'send_careerdraft/',
  getQRcode: 'get_qrcode/',
  getShogaiQRcode: '_get_shogai_qrcode/',
  requestIntroduction: '_request_introduction/',
  requestShogaiRecommend: '_request_shogai_recommend/',
  secureIntroduction: '_secure_introduction/',
  resendSecurekey: '_resend_securekey/',
  sendIntroduction: 'send_introduction/',
  sendShogaiRecommend: '_send_shogai_recommend/',
  getShogaiRecommend: '_get_shogai_recommend/',
  getIntroduction: '_get_introduction/',
  getRequestIntroduction: '_get_request_introduction/',
  sendIntroductionThank: '_send_introduction_thank/',
  updateIntroductionDisplay: '_update_introduction_display/',
  mailIntroductionPdf: '_mail_introduction_pdf/',
  sendJaic: 'send_jaic/',
  sendBaton: 'send_baton/',
  displayDialog: 'display_dialog/',
  sendRealive: 'send_realive/',
  sendNeocareer: 'send_neocareer/',
  sendHitoshia: 'send_hitoshia/',
  sendBridge: 'send_bridge/',
  sendDely: 'send_dely/',
  sendCellpromote: 'send_cellpromote/',
  sendLoginess: 'send_loginess/',
  sendAgrinavi: 'send_agrinavi/',
  sendWorkport: 'send_workport/',
  sendKrasys: 'send_krasys/',
  sendXMile: 'send_xmile/',
  testMultiMailPdf: 'test_multi_mail_pdf/',
  paymentQuickmail: 'payment_quickmail/',
  getyagishcookies: 'getyagishcookies/',
  getKakakuJobList: 'getKakakuJobList/',
  getYagiOfferList: 'getYagiOfferList/',
  readYagiOffer: 'readYagiOffer/',
  submitYagiOffer: 'submitYagiOffer/',
  denyYagiOffer: 'denyYagiOffer/',
  clickKakakuJob: 'clickKakakuJob/',
  paymentQuickemail: 'payment_quickemail/',
  checkQuickemailDuplicate: 'check_quickemail_duplicate/',
  getQuickemail: 'get_quickemail/',
  quickmailPdf: 'quickmail_pdf/',
  quickmailPdfDownload: 'quickmail_pdf_download/',
  getQuickemailList: 'get_quickemail_list/',
  getQuickmailList: 'get_quickmail_list/',
  cancelQuickemail: 'cancelQuickemail/',
  updateQuickemailScreening: 'update_quickemail_screening/',
  updateQuickemailSchedule: 'update_quickemail_schedule/',
  getQuickemailSchedule: 'get_quickemail_schedule/',
  getRtCondition: 'getRtCondition/',
  getDisableRtCondition: 'getDisableRtCondition/',
  paymentFont: 'payment_font/',
  getFontpayment: 'get_fontpayment/',
  getMypageHistory: 'get_mypage_history/',
  getMydata: 'get_mydata/',
  updateEmail: 'update_email/',
  updateMailmagaFlag: 'update_mailmaga_flag/',
  getMailmagaFlag: 'get_mailmaga_flag/',
  updateYagiofferFlag: 'update_yagioffer_flag/',
  getYagiofferFlag: 'get_yagioffer_flag/',
  getMessageBox: 'getMessageBox/',
  getTemplateAppToken: 'template_app/custom_token/',
  getPointHistory: 'get_point_history/',
  applicationCarat: 'application_carat/',
  getCaratList: 'get_carat_list/',
  getCaratDetail: 'get_carat_detail/',
  getWorkgateList: 'get_workgate_list/',
  getWorkgateDetail: 'get_workgate_detail/',
  applyWorkgate: 'apply_workgate/',
  sendMynaviBaite: 'send_mynavi_baite/',
  sendReastage: 'send_reastage/',
  sendRecruitMc: 'send_recruit_mc/',
  submitYagioffer: 'submit_yagioffer/',
  sendYagiofferCampaign: 'send_yagioffer_campaign/',
  getCompanyDetailInfo: 'get_company_detail_info/',
  sendAsiro: 'send_asiro/',
  sendCapla: 'send_capla/',
  sendRecree: 'send_recree/',
  sendGrowtrail: 'send_growtrail/',
  sendRozas: 'send_rozas/',
  sendTunaguba: 'send_tunaguba/',
  sendHrcareer: 'send_hrcareer/',
  getPaypaycodeQemail: 'get_paypaycode_qemail/',
  getPaypaycodeQmail: 'get_paypaycode_qmail/',
  getPaypaycodeFont: 'get_paypaycode_font/',
  getPaypaycodeStatus: 'get_paypaycode_status/',
  savePaypayTempdata: 'save_paypay_tempdata/',
  paypayComplateQuickemail: 'paypay_complate_quickemail/',
  paypayComplateQuickmail: 'paypay_complate_quickmail/',
  paypayComplateFont: 'paypay_complate_font/',
  siteSetting: 'site_setting/',
  registYagiofferShogai: 'regist_yagioffer_shogai/',
  subscription: 'subscription/',
  subscriptions: 'subscriptions/',
  subscriptionTypes: 'subscription_types/',
  isSubscribed: 'is_subscribed/',
  cancelSubscriptionReason: 'subscriptions/cancel/reason/',
  primeAdditionalInfo: 'prime_additional_info/',
  paymentYagiprimeQuickemail: 'payment_yagiprime_quickemail/',
  paymentYagiprimeQuickmail: 'payment_yagiprime_quickmail/',
  getQuickmailYagiprimeCount: 'get_quickmail_yagiprime_count/',
  aiIntroduce: 'ai_introduce/',
  aiIntroducePr: 'ai_introduce_pr/',
  aiSummary: 'ai_summary/',
  aiIntroduceReason: 'ai_introduce_reason/',
  aiIntroduceReasonLong: 'ai_introduce_reason_long/',
  aiEnglishProfile: 'ai_english_profile/',
  aiShogaiIntroduction: 'ai_shogai_introduction/',
  subscriptionsMypage: 'get_mypage_info/',
  isRegistrationAdditionalInfo: 'is_registration_additional_info/',
  cancelRecommendedJob: 'cancel_recommended_job/',
  detailRecommendedJob: 'detail_recommended_job/',
  applicationYagiprimecarat: 'application_yagiprimecarat/',
  applyAgent: 'apply_agent/',
  setYagiprimeEntrySource: 'set_yagiprime_entry_source/',
  applicationYagiprimecaratMail: 'application_yagiprimecarat_mail/',
  sendPleiades: 'send_pleiades/',
  sendPeacekaigo: 'send_peacekaigo/',
  sendHitotech: 'send_hitotech/',
  sendTechouse: 'send_techouse/',
  sendPharmacareer: 'send_pharmacareer/',
  sendProblemsolving: 'send_problemsolving/',
  sendHoikushikyujin: 'send_hoikushikyujin/',
  sendRealtimeTransferCommon: 'send_realtime_transfer_common/',
  sendRealtimeTransfer15: 'send_realtime_transfer_1_5/',
  clickMailmaga: 'click_mailmaga/',
  sendNewRtSystem: 'send_newrt_system/',
  sendBizreach: 'send_data_bizreach/',
  getNewRtCondition: 'getNewRtCondition/',

  getLatestSavedata: 'get_latest_savedata/',
  paypaySubscriptions: 'paypay_subscriptions/add_subscriptions/',

  getAiUsageCount: 'get_ai_usage_control/',
  aiPracticeChat: 'ai_practice_chat/',
  aiGetMotivation: 'ai_practice_chat_get/motivation/',
  updateNgCompanyList: 'update_ng_company_list/',
  getNgCompanyList: 'get_ng_company_list/',
  sendUsenworking: 'send_usenworking/',
  interviewHistory: 'interview_practice_history/',
  deleteInterview: 'delete_interview/',
  aiInterviewSheet: 'ai_interview_sheet/',
  addQuestion: 'ai_interview_sheet_add_question/',
  aiIntroduceCampusHistory: 'ai_introduce_campus_history/',
  aiIntroduceGakuchika: 'ai_introduce_gakuchika/',
  AIAutoReason: 'ai_introduce_auto_reason/',
  aiSentenseContinue: 'ai_sentense_continue/',
  aiAptitudeChat: 'ai_aptitude_chat/',
  aiSelfAnalysisChat: 'ai_self_analysis_chat/',
  aiCareerRecommendations: 'ai_career_recommendations/',
  aiExtractCompanyInfo: 'ai_extract_company_info/',
  proofreadGhost: 'proofread_ghost/',
  proofreadRewrite: 'proofread_rewrite/',
  proofreadSummarize: 'proofread_summarize/',
  proofreadEvent: 'proofread_event/',
  aiAutoRequest: 'ai_auto_request/',
  bizreachMasters: 'bizreach_masters/',

  transparencyUrl: 'transparency_image/',
  isSendCorrectionMail: 'is_send_correction_mail/',
  insertedSentence: 'inserted_sentence/',

  sendSms: 'send_data_sms/',
  getTrialCampaign: 'get_trial_campaign/',
  canUseTrialCampaign: 'can_use_trial_campaign/',
  createStripeCustomer: 'create_stripe_customer/',
  createIncompleteSubscription: 'create_incomplete_subscription/',
  createPaymentIntent: 'create_intent/',
  createQuickmailPaymentIntent: 'create_quickmail_payment_intent/',
  confirmSubscription: 'confirm_stripe_subscription/',

  registContact: 'regist_contact/',
  sendPersolinnovation: 'send_persolinnovation/',
  getNoticeinformation: 'get_noticeinformation/',
  updateDeviceToken: 'update_device_token/',
  getEprintContentscode: 'get_eprint_contentscode/',
  getPaymentHistory: 'get_payment_history/',

  getEprintQrcode: 'get_eprint_qrcode/',

  // 証明写真コンビニ印刷
  idphotoEprint: 'idphoto_eprint/',
  idphotoEprintPreview: 'idphoto_eprint_preview/',

  getStripeIntentClientSecret: 'get_stripe_intent_client_secret/',

  getDigramQuestion: 'digram/get_digram_question/',
  getDigramResult: 'digram/get_digram_result/',
  postDigramQuestionAnswer: 'digram/post_question_answer/',
  loginDigram: 'digram/login_digram/',

  availableJobCategories: 'available_job_categories/',
  availableYagilogPrivacyPolicy: 'available_yagilog_privacy_policy/',
  availableYagilogAgent: 'available_yagilog_agent/',
  saveNotificationSetting: 'save_notification_setting/',

  logConveniencePayment: 'log_convenience_payment/',
  paypayEprintPayment: 'paypay_eprint_payment/',
  savePaypayEprintTempdata: 'save_paypay_eprint_tempdata/',
  getPaypaycodeEprint: 'get_paypaycode_eprint/',
  paypayComplateEprint: 'paypay_complate_eprint/',
  getPaypayPaymentStatus: 'get_paypay_payment_status/',
  eprintRefund: 'eprint_refund/',

  // YagiFriends API
  yagiFriendsMyCluster: 'yagifriends/my-cluster/',
  yagiFriendsSimilarUsers: 'yagifriends/similar-users/',
  yagiFriendsMayKnow: 'yagifriends/may-know/',
  yagiFriendsUpdateEmbedding: 'yagifriends/update-embedding/',
  yagiFriendsCheckRegistration: 'yagifriends/check-registration/',
  yagiFriendsRegister: 'yagifriends/register/',
  yagiFriendsGoENGroups: 'yagifriends/goen/groups/',
  yagiFriendsGoENGroupDetail: 'yagifriends/goen/groups/', // + cluster_id + '/'
  yagiFriendsMyProfile: 'yagifriends/my-profile/',
  yagiFriendsUpdateMyProfile: 'yagifriends/update-my-profile/',
  yagiFriendsMemberInfo: 'yagifriends/member-info/',
  yagiFriendsWithdraw: 'yagifriends/withdraw/',
  // YagiFriends グループ機能（ユーザー作成 + 招待）
  yagiFriendsGroupIcons: 'yagifriends/groups/icons/',
  yagiFriendsGroupCreate: 'yagifriends/groups/create/',
  yagiFriendsGroupMyCreated: 'yagifriends/groups/my-created/',
  yagiFriendsMembersSearch: 'yagifriends/members/search/',
  yagiFriendsGroupBase: 'yagifriends/groups/', // + cluster_id + '/(edit|delete|invitation/create|invite-by-search|invite-by-email)/'
  yagiFriendsInvitationBase: 'yagifriends/invitation/', // + code + '/(preview|join)/'
  // YagiFriends 通知設定
  yagiFriendsGetNotificationSettings: 'yagifriends/notification-settings/',
  yagiFriendsSaveNotificationSettings: 'yagifriends/save-notification-settings/',
  yagiFriendsSendNotificationEmail: 'yagifriends/send-notification-email/',
  yagiFriendsNotifyFriendRequest: 'yagifriends/friends/request-notify/',
  yagiFriendsNotifyFriendApproved: 'yagifriends/friends/approve-notify/',
  yagiFriendsNotifyChatMention: 'yagifriends/chat/mention-notify/',
  yagiFriendsNotifyChatGroup: 'yagifriends/chat/group-notify/',
  yagiFriendsNotifyChatDirect: 'yagifriends/chat/direct-notify/',
  yagiFriendsTrackEvent: 'yagifriends/track-event/',

  // 履歴書OCR API
  parseResume: 'parse_resume/',
  ocrHistoryApplied: 'ocr_history_applied/',

  // ヤギディア API
  getYagiOfferJobs: 'getYagiOfferJobs/',
  submitYagiOfferJobs: 'submitYagiOfferJobs/',

  // Aptitude Tekisei Endpoints
  aptitudeTekiseiLogin: 'aptitude/tekisei/login/',
  aptitudeTekiseiLogout: 'aptitude/tekisei/logout/',
  aptitudeTekiseiHome: 'aptitude/tekisei/home/',
  aptitudeTekiseiSurveyDs: 'aptitude/tekisei/survey/ds/',
  aptitudeTekiseiSurveyDsSave: 'aptitude/tekisei/survey/ds/save/',
  aptitudeTekiseiSurveyPs: 'aptitude/tekisei/survey/ps/',
  aptitudeTekiseiSurveyPsSave: 'aptitude/tekisei/survey/ps/save/',

  // Skill Diagnosis
  runSkillDiagnosis: 'diagnosis/run_skill_diagnosis/',
  runSkillDiagnosisLite: 'diagnosis/run_skill_diagnosis_lite/'

}

const Varuna = {
  install: function (Vue, options) {
    const main = new Vue({
      data: function () {
        return {
          healthCheckIntervalTimer: {},
          apiAvailable: null
        }
      },
      computed: {
        endPoints: function () {
          const endPoints = {}
          _.forEach(ENDPOINT_VALUES, function (value, key) {
            endPoints[key] = ENEPOINT_PREFIX + value
          })
          return endPoints
        }
      },
      methods: {
        apiHealthCheck: function () {
          const app = this
          this.$axios.get(app.endPoints.healthcheck).then(
            function (response) {
              app.apiAvailable = true
            }
          ).catch(
            function (error) {
              console.error(error)
              app.apiAvailable = false
            }
          )
        },
        init: function () {
          // this.apiHealthCheck()
          // this.healthCheckIntervalTimer = setInterval(this.apiHealthCheck, HEALTH_CHECK_INTERVAL_MS)
        }
      },
      watch: {
        apiAvailable: function (newVal, oldVal) {
          // console.log('apiAvailable', oldVal, newVal)
          if (oldVal === true && newVal === false) {
            this.$message({
              message: '現在PDFダウンロードが利用できません',
              type: 'error'
            })
          }
          if (oldVal === false && newVal === true) {
            this.$message({
              message: 'PDFダウンロードが利用できるようになりました',
              type: 'success'
            })
          }
        }
      }
    })
    main.init()
    Vue.prototype.$varuna = main
  }
}
export default Varuna
